import {CBObject} from '../base/cBObject';

export interface ExternalRef {
    ref?: string;
    type?: string;
}

export enum ChargeRecordStatus {
    PREPARING = 'PREPARING',
    CHARGING = 'CHARGING',
    CHARGING_KO = 'CHARGING_KO',
    STOPPED = 'STOPPED',
    STOPPED_KO = 'STOPPED_KO',
    VALORISED = 'VALORISED',
    PREPARING_MODIFIED = 'PREPARING_MODIFIED',
    MODIFIED = 'MODIFIED',
    MODIFIED_KO = 'MODIFIED_KO',
}

export interface DataEntry extends CBObject {
    basePrice?: number;
    cdrRef?: string;
    d?: number;
    ts?: number;
    v?: number;
}
